module.exports = __webpack_public_path__ + "static/media/img-talentx-desktop-wallpaper@2x.45562079.png";